import script from "./Charts.vue?vue&type=script&setup=true&lang=js"
export * from "./Charts.vue?vue&type=script&setup=true&lang=js"

import "./Charts.vue?vue&type=style&index=0&id=3c384e70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c384e70"]])

export default __exports__